import { getProxyApiUrl } from 'in-meeting-experience-ui-components/utils/general';
import noAuthClient from '../../utils/apiClient';
const proxyApiUrl = getProxyApiUrl();
const getParticipantsApiBase = meetingUid => `${proxyApiUrl}/in-meeting-experience/v1/meetings/${encodeURIComponent(meetingUid)}/participants`;
export const fetchMeetingParticipants = ({
  meetingUid
}) => noAuthClient.get(`${getParticipantsApiBase(meetingUid)}`);
export const saveMeetingParticipants = ({
  data,
  meetingUid
}) => noAuthClient.post(`${getParticipantsApiBase(meetingUid)}/batch`, {
  data
});
export const mapParticipantToContact = ({
  participantId,
  contactId,
  meetingUid
}) => noAuthClient.post(`${getParticipantsApiBase(meetingUid)}/${participantId}/map-to-contact/${contactId}`);
export const removeParticipantMapping = ({
  participantId,
  contactId,
  meetingUid
}) => noAuthClient.delete(`${getParticipantsApiBase(meetingUid)}/${participantId}/map-to-contact/${contactId}`);